export default "__VITE_ASSET__Cp_Su1Li__"